module.exports = __webpack_public_path__ + "img/cc-mc.8344e47d.svg";